<template>
  <section class="lms-container">
    <div class="content">
    <div class="breadcrumb" style="border: none !important;"></div>

      <div class="buttons"  v-if="userType == 0">
        <button v-on:click="loadCoursePage(null)" class="btn btn-primary">
          <i class="fa fa-plus"></i>&nbsp;Incluir Novo
        </button>
      </div>

      <table class="footable table table-bordered table-striped table-highlight">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th class="tcenter">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="course in courses" :key="course.id">
            <td>{{course.id}}</td>
            <td>{{course.name}}</td>
             <td class="tcenter">
              <div v-if="removeItem!=course.id">
                <button v-on:click="loadCoursePage(course)" class="btn btn-default md">
                  Editar
                  <i class="fa fa-edit"></i>
                </button>
                <a v-on:click="removeItem=course.id" class="btn btn-default md" v-if="userType == 0">
                  Remover
                  <i class="fa fa-trash"></i>
                </a>
              </div>
              <div class="parent" v-else>
                <p class="child">Tem certeza que deseja remover o curso selecionado?</p>
                <a v-on:click="removeItem=0" class="child btn btn-danger md">
                  Cancelar
                </a>
                <a v-on:click="removeCourse(course)" class=" child btn btn-success md">
                  Confirmar
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      courses: [],
      removeItem:0,
      userType: this.$store.getters.user.type,
    };
  },
  components: {
  },
  methods: {
    loadCoursePage(course) {
      if(course == null)
        course = {};
      this.$store.commit("change_course", course);
      this.$router.push({ name: "editcourse", params: { course: course } });
    },
    removeCourse(course) {
      const path = this.$global.endpoint + "/course/remove";
      axios
        .post(path, { courseId: course.id })
        .then(res => {
          this.getCourses();
        })
        .catch(error => {
          console.error(error);
        });
    },

    getCourses() {
      const path = this.$global.endpoint + "/course/getall";
      axios
        .get(path)
        .then(res => {
          this.courses = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.getCourses();
  }
};
</script>
